/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class DocumentConfiguration implements IDirective {
        public controller = ["$scope", "documentService", "securityMatrixService", DocumentConfigurationController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/documentConfiguration.html';
        public restrict: string = "E";

        public scope: any = {
            documentConfiguration: "=",
            systemDocumentConfiguration: "=",
            processConfigurationId: "=",
            allowMultipleFiles: "="
        };

        public link(scope: IDocumentConfigurationScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: DocumentConfigurationController): void {
        }
    }

    export interface IDocumentConfigurationScope extends ng.IScope {
        documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration;
        systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        processConfigurationId: string;
        allowMultipleFiles: boolean;
        save(): void;
        selectAllDocumentTypes(): void;
        unSelectAllDocumentTypes(): void;
        documentSecurityChanged(): void;
    }

    export class DocumentConfigurationController implements IController {

        private isSystemLevel: boolean;

        constructor(
            private $scope: IDocumentConfigurationScope,
            private documentService: services.DocumentService,
            private securityMatrixService: services.SecurityMatrixService)
        {
            this.createMissingAvailableDocuments();

            this.$scope.save = () => this.save();
            this.$scope.selectAllDocumentTypes = () => this.selectAllDocumentTypes();
            this.$scope.unSelectAllDocumentTypes = () => this.unSelectAllDocumentTypes();
            this.$scope.documentSecurityChanged = () => this.documentSecurityChanged();

            this.$scope.$watch("documentConfiguration", () => {
                this.createMissingAvailableDocuments();
                this.isSystemLevel = this.$scope.documentConfiguration.systemLevel_id !== null;
            });
        }

        private createMissingAvailableDocuments(): void {
            for (var i = 0; i < this.$scope.systemDocumentConfiguration.documentTypeCodeGroup.codes.length; i++) {
                var currentSystemCode = this.$scope.systemDocumentConfiguration.documentTypeCodeGroup.codes[i];
                if (!currentSystemCode.isActive) continue;
                if (!Enumerable.from(this.$scope.documentConfiguration.myAvailableDocumentTypes).any(i => i.systemCode_id === currentSystemCode.id)) {
                    var newAvailableDocType = this.documentService.createAvailableDocumentType(this.$scope.documentConfiguration, currentSystemCode);
                    this.$scope.documentConfiguration.myAvailableDocumentTypes.push(newAvailableDocType);
                }
            }
        }

        private selectAllDocumentTypes(): void {
            for (var i = 0; i < this.$scope.documentConfiguration.myAvailableDocumentTypes.length; i++) {
                this.$scope.documentConfiguration.myAvailableDocumentTypes[i].isAvailable = true;
            }
            this.save();
        }

        private unSelectAllDocumentTypes(): void {
            for (var i = 0; i < this.$scope.documentConfiguration.myAvailableDocumentTypes.length; i++) {
                this.$scope.documentConfiguration.myAvailableDocumentTypes[i].isAvailable = false;
            }
            this.save();
        }

        public documentSecurityChanged() {
            if (!this.$scope.documentConfiguration.documentSecurity) return;

            switch (this.$scope.documentConfiguration.documentSecurity) {
                case Wars.Domain.Model.Codes.Enums.DocumentSecurity.NotSecured:
                    break;

                case Wars.Domain.Model.Codes.Enums.DocumentSecurity.CanBeMarkedSecured:
                    if (!this.$scope.documentConfiguration.canSecureDocumentSecurityMatrix) {
                        this.$scope.documentConfiguration.canSecureDocumentSecurityMatrix = this.securityMatrixService.createSecurityMatrix(this.isSystemLevel);
                    }
                    if (!this.$scope.documentConfiguration.canDownloadSecureDocumentSecurityMatrix) {
                        this.$scope.documentConfiguration.canDownloadSecureDocumentSecurityMatrix = this.securityMatrixService.createSecurityMatrix(this.isSystemLevel);
                    }
                    if (!this.$scope.documentConfiguration.securedDocumentLabel) {
                        this.$scope.documentConfiguration.securedDocumentLabel = "Is Document Secured";
                    }
                    break;

                case Wars.Domain.Model.Codes.Enums.DocumentSecurity.IsSecured:
                    if (!this.$scope.documentConfiguration.canDownloadSecureDocumentSecurityMatrix) {
                        this.$scope.documentConfiguration.canDownloadSecureDocumentSecurityMatrix = this.securityMatrixService.createSecurityMatrix(this.isSystemLevel);
                    }
                    break;

                default:
            }
            this.save();
        }

        private save(): void {
            this.documentService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('DocumentConfiguration', []);